module.exports = "/_next/static/images/img__teachers_right_top_desktop-0e68b8f6f7a6421f892e545757af14b2.png";